import { CommonModule } from '@angular/common';
import { ComponentFactory, ComponentFactoryResolver, ModuleWithProviders, NgModule, Type, inject, provideAppInitializer } from '@angular/core';
import { OutletDirective } from './outlet.directive';
import { OutletPosition } from './outlet.model';
import { ProvideOutletOptions, PROVIDE_OUTLET_OPTIONS } from './outlet.providers';
import { OutletService } from './outlet.service';

/**
 * @private
 */
export function registerOutletsFactory(
  providedOutletOptions: ProvideOutletOptions[],
  componentFactoryResolver: ComponentFactoryResolver,
  outletService: OutletService<ComponentFactory<Type<any>>>,
): () => void {
  const result = () => {
    (providedOutletOptions ?? []).forEach((options) => {
      const factory = componentFactoryResolver.resolveComponentFactory(options.component);
      outletService.add(options.id, factory, options.position ?? OutletPosition.AFTER);
    });
  };
  return result;
}

@NgModule({
  imports: [CommonModule],
  declarations: [OutletDirective],
  exports: [OutletDirective],
})
export class OutletModule {
  static forRoot(): ModuleWithProviders<OutletModule> {
    return {
      ngModule: OutletModule,
      providers: [
        provideAppInitializer(() =>
          registerOutletsFactory(
            inject(PROVIDE_OUTLET_OPTIONS, { optional: true }) ?? [],
            inject(ComponentFactoryResolver),
            inject(OutletService)
          )()
        ),
      ],
    };
  }
}
